import moment from "moment";
import axios from "axios";
import fs from "@/services/FormatService";

function compileCompletionStats(data) {
	let stats = data.completion;
	let assessments = data.assessments;
	let contentAreas = data.content_areas;
	let grades = data.grades;

	let gradeGroups = {};
	_.each(assessments, asmt => {
		let asmtGrades = [];
		_.each(asmt.grade_ids, gid => {
			asmtGrades.push(grades[gid]);
		});
		asmtGrades = _.sortBy(asmtGrades, ["sequence"]);
		let groupID = _.map(asmtGrades, g => {
			return g.sequence.toString().padStart(3, "0");
		}).join("");
		let groupName = _.map(asmtGrades, "name").join(" / ");
		gradeGroups[groupID] = { id: groupID, name: groupName };
		asmt.grade_group_id = groupID;
	});

	gradeGroups = _.sortBy(gradeGroups, "id");

	let overall = {
		complete: 0,
		unscored: 0,
		resolution: 0,
		reliability: 0,
		resolution_complete: 0,
		total: 0
	};
	let statTypes = {
		unscored: { state: 1, total: true },
		reliability: { state: 2, total: true },
		resolution: { state: 3, total: true },
		complete: { state: 10, total: true },
		resolution_complete: { state: 100 }
	};
	let cas = [];
	_.each(contentAreas, (name, id) => {
		let ca = {
			id: id,
			name: name,
			grades: []
		};

		let caTotals = {
			complete: 0,
			unscored: 0,
			resolution: 0,
			reliability: 0,
			resolution_complete: 0,
			total: 0
		};

		_.each(gradeGroups, gradeGroup => {
			let asmts = _.filter(assessments, {
				ca_id: ca.id,
				grade_group_id: gradeGroup.id
			});

			_.each(asmts, asmt => {
				asmt.total = 0;
				_.each(statTypes, (st, name) => {
					let stat = _.find(stats, {
						asmt_id: asmt.id,
						state: st.state
					});
					asmt[name] = stat ? stat.count : 0;
					if (st.total) {
						asmt.total += asmt[name];
					}
				});

				caTotals.complete += asmt.complete;
				caTotals.unscored += asmt.unscored;
				caTotals.resolution += asmt.resolution;
				caTotals.reliability += asmt.reliability;
				caTotals.resolution_complete += asmt.resolution_complete;
				caTotals.total += asmt.total;
			});

			if (asmts.length > 0) {
				let caGradeGroup = _.cloneDeep(gradeGroup);
				caGradeGroup.assessments = asmts;
				ca.grades.push(caGradeGroup);
			}
		});

		overall.complete += caTotals.complete;
		overall.unscored += caTotals.unscored;
		overall.resolution += caTotals.resolution;
		overall.reliability += caTotals.reliability;
		overall.resolution_complete += caTotals.resolution_complete;
		overall.total += caTotals.total;

		ca.totals = caTotals;
		cas.push(ca);
	});

	return { overall: overall, statTree: cas };
}

export default {
	getBasicStats() {
		return axios.get("/v1/admin/stat/basic");
	},

	getUserCompletion(userID) {
		return axios.get(`/v3/user/${userID}/completion`);
	},

	getClassCompletion(classID) {
		return axios.get(`/v3/class/${classID}/completion`);
	},

	getAssessmentCompletion(classID, assessmentID) {
		return axios.get(
			`/v3/class/${classID}/assessment/${assessmentID}/completion`
		);
	},

	getAssessmentAgreement(classID, assessmentID) {
		return axios.get(
			`/v3/class/${classID}/assessment/${assessmentID}/agreement`
		);
	},

	getUsageCounts() {
		return axios.get(`/v3/overall/usage/counts`);
	},

	getOverallCompletion() {
		return axios.get(`/v3/overall/completion`);
	},

	getLoginVolume() {
		return axios.get(`/v3/logins/volume`, {
			params: {
				rt: moment().toISOString(true)
			}
		});
	},

	getAssessmentsByAssignments() {
		return axios.get(`/v3/overall/assessments`);
	},

	getAssessmentSummaryStats(
		assessment,
		scoreTypesLeft,
		userLeft,
		scoreTypesRight,
		userRight
	) {
		return axios.post("/v3/stat/assessment_summary", {
			asmt_id: assessment,
			stl: scoreTypesLeft,
			user_l: userLeft,
			str: scoreTypesRight,
			user_r: userRight
		});
	},

	getCompletionStats(showEmpty) {
		let ctx = {};
		if (showEmpty) {
			ctx.params = { e: true };
		}

		return new Promise(function (resolve, reject) {
			axios
				.get(`/v3/completion/stats`, ctx)
				.then(resp => {
					var compiledData = compileCompletionStats(resp.data);
					resolve({ data: compiledData });
				})
				.catch(err => {
					console.log(err);
					reject(err);
				});
		});
	},

	getScorerStats(ctx) {
		return axios.post("/v3/stat/scorers", ctx);
	},

	compileUserAgreement(data) {
		let totals = {
			irr_exact: 0,
			irr_exact_adj: 0,
			irr_total: 0,
			val_exact: 0,
			val_exact_adj: 0,
			val_total: 0,
			res_required: 0,
			res_changed: 0,
			res_total: 0
		};
		let num = 0;

		_.each(data, stat => {
			num++;
			stat.scorer = fs.scorerID(stat.user);
			totals.irr_exact += stat.irr_exact;
			totals.irr_exact_adj += stat.irr_exact_adj;
			totals.irr_total += stat.irr_total;

			totals.val_exact += stat.val_exact;
			totals.val_exact_adj += stat.val_exact_adj;
			totals.val_total += stat.val_total;

			totals.res_required += stat.res_required;
			totals.res_changed += stat.res_changed;
			totals.res_total += stat.res_total;

			stat.irr_exact_percent = (stat.irr_exact * 100) / stat.irr_total;
			stat.irr_exact_adj_percent =
				(stat.irr_exact_adj * 100) / stat.irr_total;

			stat.val_exact_percent = (stat.val_exact * 100) / stat.val_total;
			stat.val_exact_adj_percent =
				(stat.val_exact_adj * 100) / stat.val_total;

			stat.res_required_percent =
				(stat.res_required * 100) / stat.res_total;
			stat.res_changed_percent =
				(stat.res_changed * 100) / stat.res_total;

			_.each(stat.traits, trait => {
				trait.irr_exact_percent =
					(trait.irr_exact * 100) / trait.irr_total;
				trait.irr_exact_adj_percent =
					(trait.irr_exact_adj * 100) / trait.irr_total;

				trait.val_exact_percent =
					(trait.val_exact * 100) / trait.val_total;
				trait.val_exact_adj_percent =
					(trait.val_exact_adj * 100) / trait.val_total;

				trait.res_required_percent =
					(trait.res_required * 100) / trait.res_total;
				trait.res_changed_percent =
					(trait.res_changed * 100) / trait.res_total;
			});
		});

		totals.scorer = `Totals (${num})`;
		totals.irr_exact_percent = (totals.irr_exact * 100) / totals.irr_total;
		totals.irr_exact_adj_percent =
			(totals.irr_exact_adj * 100) / totals.irr_total;

		totals.val_exact_percent = (totals.val_exact * 100) / totals.val_total;
		totals.val_exact_adj_percent =
			(totals.val_exact_adj * 100) / totals.val_total;

		totals.res_required_percent =
			(totals.res_required * 100) / totals.res_total;
		totals.res_changed_percent =
			(totals.res_changed * 100) / totals.res_total;

		return { stats: data, totals: totals };
	},

	getAgreementUsers(assessmentID) {
		return new Promise((resolve, reject) => {
			axios
				.get(`/v3/stat/user_agreement/${assessmentID}`)
				.then(resp => {
					var compiledData = this.compileUserAgreement(
						resp.data.user_stats
					);
					resolve({ data: compiledData });
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getSchoolScores(districtID, schoolID) {
		return axios.get(`/v3/report/school/${districtID}/${schoolID}/scores`);
	},

	getDistrictScores(districtID) {
		return axios.get(`/v3/report/district/${districtID}/scores`);
	},

	getSchoolCompletion(districtID, schoolID) {
		return axios.get(
			`/v3/report/school/${districtID}/${schoolID}/completion`
		);
	},

	getSchoolScoreVolume(districtID, schoolID) {
		return axios.get(`/v3/report/school/${districtID}/${schoolID}/volume`, {
			params: { rt: moment().toISOString(true) }
		});
	},

	getSchoolProgress(districtID, schoolID, assessmentID) {
		return axios.get(
			`/v3/report/school/${districtID}/${schoolID}/progress/${assessmentID}`
		);
	},

	getCompletionDetailList(
		districtID,
		schoolID,
		assessmentID,
		classID,
		compType
	) {
		return axios.get(
			`/v3/report/comp_details_list/${districtID}/${schoolID}/${assessmentID}/${classID}/${compType}`
		);
	}
};



// WEBPACK FOOTER //
// ./src/services/ReportingService.js